import { render, staticRenderFns } from "./EditCampaignMessage.vue?vue&type=template&id=433a531a&scoped=true&"
import script from "./EditCampaignMessage.vue?vue&type=script&lang=js&"
export * from "./EditCampaignMessage.vue?vue&type=script&lang=js&"
import style0 from "./EditCampaignMessage.vue?vue&type=style&index=0&id=433a531a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a531a",
  null
  
)

export default component.exports